var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickPay = function SvgQuickPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.525 15-.025.333c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-1 1.667-1.667l.363-4.833M6.525 15l.225-3m-.225 3h-2.05m2.275-3 .113-1.5M6.75 12H3.475m3.388-1.5L6.975 9m-.112 1.5h15M6.975 9 7 8.667C7 7.747 7.746 7 8.667 7h11.666C21.253 7 22 7.746 22 8.667l-.137 1.833M6.975 9h-4.5m7.015 5h.01m3.5 0h2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgQuickPay;